module.exports = __webpack_public_path__ + "img/logo.28622a39.png";